import HubSpotVideoPlayer from 'ui-addon-video-player/components/HubSpotVideoPlayer';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { jsx as _jsx } from "react/jsx-runtime";
export default function VideoSection() {
  const {
    width
  } = useResponsiveProps({
    width: {
      [ScreenSizes.XS]: undefined,
      [ScreenSizes.MD]: '75%'
    }
  });
  return /*#__PURE__*/_jsx("div", {
    className: "p-y-10",
    style: {
      margin: 'auto',
      width
    },
    children: /*#__PURE__*/_jsx(HubSpotVideoPlayer, {
      autoPlay: true,
      mutedByDefault: true,
      videoId: 124830715965
    })
  });
}